import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { ConfirmContext } from '../../contexts/confirm.context';
import { IBar } from '../../models/IBars';
import { IReport } from '../../models/IReport';
import BarDetailsPage from '../../pages/BarDetails/BarDetails.page';
import BarsService from '../../services/bar/bar.service';

export default function BarDetailsContainer() {
    const history = useHistory();
    const params = useParams<any>();

    const [entry, setEntry] = useState<IBar>();
    const [reports, setReports] = useState<IReport>()
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);

    const { show } = useContext(ConfirmContext);


    useEffect(() => {
        let mounted = true;

        setLoading(true);
        setFailed(false);

        Promise.all([
            BarsService.getBar(params.id),
            BarsService.getReports(params.id)
        ]).then(([bar, reportsData]) => {
            if (!mounted) {
                return;
            }

            if (!bar) {
                setFailed(true);
                show({
                    title: "Bar not found",
                    message: "We couldn't load that bar. Returning you to dashboard.",
                    actions: [
                        {
                            title: "OK",
                            role: "cancel",
                            style: { color: "#fff" }
                        }
                    ]
                });
                history.replace("/dashboard?view=bars");
                return;
            }

            setEntry(bar);
            setReports(reportsData);
        }).catch(() => {
            if (!mounted) {
                return;
            }

            setFailed(true);
            show({
                title: "Unable to load bar",
                message: "Something went wrong while loading this bar. Please try again.",
                actions: [
                    {
                        title: "OK",
                        role: "cancel",
                        style: { color: "#fff" }
                    }
                ]
            });
            history.replace("/dashboard?view=bars");
        }).finally(() => {
            if (mounted) {
                setLoading(false);
            }
        });

        return () => {
            mounted = false;
        }
    }, [params.id])

    const deleteEntry = () => {
        console.log('deleting entry');
    }

    const onEditClick = () => {
        history.push(`/manage-bar/${entry.id}`)
    }

    const onDeleteClick = () => {
        show({
            title: `Delete ${entry?.name}`,
            message: `Are you sure you want to delete ${entry?.name}`,
            actions: [
                {
                    title: 'No',
                    role: 'cancel',
                    style: { color: '#fff' }
                },
                {
                    title: 'Yes',
                    role: 'destructive',
                    style: { backgroundColor: '#DF2727', color: '#fff' },
                    handler: async () => {
                        await BarsService.deleteBar(entry.id);
                        history.replace("/dashboard?view=bars")
                    }
                }
            ]
        });
    }

    if (loading) {
        return <div style={{ color: "#fff", padding: "2rem" }}>Loading bar details...</div>;
    }

    if (failed || !entry) {
        return <div style={{ color: "#fff", padding: "2rem" }}>Unable to load bar details.</div>;
    }

    return (
        <BarDetailsPage
            entry={entry}
            reports={reports}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
        />
    )
}
